import Intercom from '@intercom/messenger-js-sdk';

const APP_ID = 'y9ldbtxq';
// Identifies this product to the Orcanos support team in the shared Intercom workspace —
// shows as a Company on the contact, plus a plain custom attribute as a fallback in case
// "Company" isn't what support actually looks at. Mirrors the same pattern in Ask Paul's
// frontend/src/intercom.js.
const CALLING_APP = 'Traceability Matrix';
const CALLING_APP_ID = 'traceability-matrix';
let booted = false;

// `user` is whatever /api/auth/status returns — only `user_id` and `account_name` are
// reliably present (no email/display name on the session), so this only ever identifies
// the visitor by id and tenant, never boots with a name/email.
function userFields(user) {
  return {
    ...(user?.user_id ? { user_id: String(user.user_id) } : {}),
    company: { company_id: CALLING_APP_ID, name: CALLING_APP },
    app_name: CALLING_APP,
    ...(user?.account_name ? { account_name: user.account_name } : {}),
  };
}

// Boots the widget once, anonymously if no user is known yet (e.g. the login screen).
export function bootIntercom(user) {
  if (booted) return;
  // Bottom-right: on the left it covered the nav's last entries and the credits row
  // (AppNav `NavCredits`). Intercom's launcher cannot be dragged — it is their iframe.
  Intercom({ app_id: APP_ID, alignment: 'right', vertical_padding: 8, ...userFields(user) });
  booted = true;
}

// Identifies/updates the visitor once user info becomes available (e.g. after login).
export function updateIntercomUser(user) {
  if (!user || !window.Intercom) return;
  window.Intercom('update', userFields(user));
}

export function showIntercom() {
  if (window.Intercom) {
    window.Intercom('show');
  } else {
    window.open('https://www.orcanos.com', '_blank');
  }
}
